import { useState } from "react";
import { toast } from "sonner";
import { api, setGuestSession, formatError } from "../lib/api";

export const GuestCodeForm = ({ onSuccess }) => {
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!code.trim()) return;
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/guest/access", { code: code.trim() });
      const session = { token: data.guest_token, name: data.name, rsvp: data.rsvp || null };
      setGuestSession(session);
      toast.success(`¡Bienvenido, ${data.name}!`);
      onSuccess(session);
    } catch (err) {
      setError(formatError(err, "Código no válido. Revisa tu invitación."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <form data-testid="guest-code-form" onSubmit={submit} className="mt-8 space-y-4">
      <label className="block text-[11px] uppercase tracking-[0.35em] text-stone text-center">
        Tu código de invitado
      </label>
      <input
        data-testid="guest-code-input"
        value={code}
        onChange={(e) => setCode(e.target.value.toUpperCase())}
        placeholder="XXXXXX"
        maxLength={8}
        className="w-full bg-cream border border-clay/25 rounded-2xl px-6 py-4 text-center text-xl tracking-[0.5em] font-mono text-ink placeholder:text-stone/40 focus:outline-none focus:border-clay transition-colors"
      />
      {error && (
        <p data-testid="guest-code-error" className="text-center text-sm text-red-800">
          {error}
        </p>
      )}
      <button
        data-testid="guest-code-submit"
        type="submit"
        disabled={loading}
        className="w-full rounded-full bg-clay text-cream py-4 text-[11px] uppercase tracking-[0.3em] hover:bg-clay-deep transition-colors disabled:opacity-60"
      >
        {loading ? "Verificando…" : "Continuar"}
      </button>
    </form>
  );
};
